import { Container, Divider, Grid, Link, Paper, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const SurveyComplete: React.FC = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Container maxWidth="sm">
      <Paper className={classes.paper} elevation={1}>
        <Grid container spacing={3} direction="column" alignItems="center">
          <Grid>
            <Typography variant="h4" align="center">{t('surveyEndThanks')}</Typography>
          </Grid>
          <Grid size={10}>
            <Divider className={classes.divider} />
          </Grid>
          <Grid>
            <Typography variant="body1" align="center">{t('surveyEndSuccess')}</Typography>
          </Grid>
          <Grid>
            <Typography variant="body1" align="center">{t('surveyEndGreetings')}</Typography>
          </Grid>
          <Grid size={10}>
            <Divider className={classes.divider} />
          </Grid>
          <Grid>
            <Typography variant="body2" align="center" color="textSecondary">
              <Trans i18nKey="infoAboutAI">
                Information about our AI can be found
                <Link className={classes.link} href="https://www.secret-ai-agent.de/technologie" target="_blank" underline="hover">
                  here.
                </Link>
              </Trans>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(5, 4),
    borderRadius: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 2),
    },
  },
  divider: {
    margin: theme.spacing(1, 0),
    borderColor: theme.palette.secondary.main,
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.secondary.main,
  },
}));

export default React.memo(SurveyComplete);
